import { useEffect } from 'react';
import { useTrackPage } from 'Tracking/tracking-api/useTrackPage';
type Props = {
  pageName: string;
  payload?: TrackPayload;
};
export const TrackPage = ({ pageName, payload }: Props) => {
  const { trackPage } = useTrackPage();
  useEffect(() => {
    trackPage(pageName, payload);
  }, [pageName]);
  return null;
};
